<template>
  <div>
    <!-- 列表模式 -->
    <template v-if="!printMode">
      <a-row :gutter="24">
        <a-col :md="24">
          <a-card :bordered="false">
            <div class="table-page-search-wrapper">
              <a-form layout="inline" @keyup.enter.native="searchQuery">
                <a-row :gutter="24">
                  <a-col :md="6" :sm="24">
                    <a-form-item label="门店" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <store-tenant-select domain="stock" @change="handleStoreTenantChange"></store-tenant-select>
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24">
                    <a-form-item label="序列号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-input placeholder="请输入序列号" v-model="queryParam.serialNumber"></a-input>
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24">
                    <a-form-item label="商品" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-input placeholder="条码/名称/助记码/规格/型号" v-model="queryParam.materialParam"></a-input>
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24">
                    <a-form-item label="单号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-input placeholder="请输入单号" v-model="queryParam.billNo"></a-input>
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24">
                    <span class="table-page-search-submitButtons">
                      <a-button type="primary" @click="searchQuery">查询</a-button>
                      <a-button style="margin-left: 8px" @click="searchReset">重置</a-button>
                      <a-button style="margin-left: 8px" icon="printer" v-if="btnEnableList.indexOf('5') > -1" @click="handlePrint">打印</a-button>
                      <a-button style="margin-left: 8px" icon="download" v-if="btnEnableList.indexOf('3') > -1" @click="exportExcel">导出</a-button>
                      <a @click="toggleSearchStatus = !toggleSearchStatus" style="margin-left: 8px">
                        {{ toggleSearchStatus ? '收起' : '展开' }}
                        <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
                      </a>
                    </span>
                  </a-col>
                </a-row>
                <template v-if="toggleSearchStatus">
                  <a-row :gutter="24">
                    <a-col :md="6" :sm="24">
                      <a-form-item label="已出库" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-select placeholder="请选择已出库" allow-clear v-model="queryParam.isSell">
                          <a-select-option v-for="(item, index) in sellTypeList" :key="index" :value="item.value">{{ item.text }}</a-select-option>
                        </a-select>
                      </a-form-item>
                    </a-col>
                    <a-col :md="6" :sm="24">
                      <a-form-item label="仓库" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-select placeholder="请选择仓库" allow-clear v-model="queryParam.depotId">
                          <a-select-option v-for="(item, index) in depotList" :key="index" :value="item.id">{{ item.depotName }}</a-select-option>
                        </a-select>
                      </a-form-item>
                    </a-col>
                    <a-col :md="6" :sm="24">
                      <a-form-item label="商品类别" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-tree-select
                          style="width: 100%"
                          :dropdownStyle="{ maxHeight: '200px', overflow: 'auto' }"
                          allow-clear
                          :treeData="categoryTree"
                          v-model="queryParam.categoryId"
                          placeholder="请选择商品类别">
                        </a-tree-select>
                      </a-form-item>
                    </a-col>
                  </a-row>
                </template>
              </a-form>
            </div>

            <div style="margin-bottom: 8px;">
              <span style="font-size: 14px; font-weight: 500;">序列号总价：{{ inPriceTotalStr }}</span>
            </div>

            <a-table
              bordered
              ref="table"
              size="middle"
              rowKey="id"
              :columns="columns"
              :dataSource="dataSource"
              :pagination="false"
              :loading="loading"
              :scroll="{ x: 1800 }"
              @change="handleTableChange">
              <span slot="inBillNoCustomRender" slot-scope="text, record">
                <a v-if="record.inBillNo" @click="handleBillClick(record.inBillNo)">{{ record.inBillNo }}</a>
                <span v-else></span>
              </span>
              <span slot="outBillNoCustomRender" slot-scope="text, record">
                <a v-if="record.outBillNo" @click="handleBillClick(record.outBillNo)">{{ record.outBillNo }}</a>
                <span v-else></span>
              </span>
            </a-table>
            <a-row :gutter="24" style="margin-top: 8px; textAlign: right">
              <a-col :md="24" :sm="24">
                <a-pagination
                  @change="paginationChange"
                  @showSizeChange="paginationShowSizeChange"
                  size="small"
                  show-size-changer
                  show-quick-jumper
                  :current="ipagination.current"
                  :page-size="ipagination.pageSize"
                  :page-size-options="ipagination.pageSizeOptions"
                  :total="ipagination.total"/>
              </a-col>
            </a-row>
          </a-card>
        </a-col>
      </a-row>
    </template>

    <!-- 打印模式 -->
    <template v-if="printMode">
      <div style="display:flex; justify-content:space-between; align-items:center; padding:8px 16px; background:#fff; border-bottom:1px solid #e8e8e8; margin-bottom:12px;">
        <span style="font-size:16px; font-weight:500;">{{ printTitle }}</span>
        <a-button icon="close" @click="printMode = false">关闭</a-button>
      </div>
      <ReportPrint
        :visible="true"
        :tableData="printDataSource"
        :queryParam="queryParam"
        billType="SERIAL_NUMBER_STATISTICS"
        billTypeName="序列号统计"
        :buildData="buildPrintData"
        :embedded="true"
        @designer-change="onDesignerChange"
        @back="printMode = false"/>
    </template>

    <bill-detail ref="modalDetail" @ok="modalFormOk" @close="modalFormClose"></bill-detail>
  </div>
</template>

<script>
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import { queryMaterialCategoryTreeList } from '@/api/api'
  import { getAction } from '@/api/manage'
  import { getLoginName } from '@/utils/util'
  import ReportPrint from '@/views/plugin/print-template/ReportPrint.vue'
  import StoreTenantSelect from '@/components/StoreTenantSelect'
  import BillDetail from '@/views/bill/dialog/BillDetail'

  export default {
    name: 'SerialNumberStatisticsList',
    mixins: [JeecgListMixin],
    components: {
      ReportPrint,
      StoreTenantSelect,
      BillDetail
    },
    data() {
      return {
        labelCol: { span: 6 },
        wrapperCol: { span: 17, offset: 1 },
        queryParam: {
          serialNumber: '',
          materialParam: '',
          isSell: undefined,
          depotId: undefined,
          billNo: '',
          categoryId: undefined
        },
        ipagination: {
          current: 1,
          pageSize: 11,
          pageSizeOptions: ['10', '20', '30', '50', '100'],
          total: 0
        },
        sellTypeList: [
          { text: '是', value: '1' },
          { text: '否', value: '0' }
        ],
        depotList: [],
        categoryTree: [],
        inPriceTotalStr: '0.00',
        columns: [
          {
            title: '序号', dataIndex: 'rowIndex', width: 50, align: 'center',
            customRender: function (t, r, index) { return (t !== '合计') ? (parseInt(index) + 1) : t }
          },
          { title: '序列号', dataIndex: 'serialNumber', width: 150, ellipsis: true },
          { title: '条码', dataIndex: 'materialCode', width: 120, ellipsis: true },
          { title: '名称', dataIndex: 'materialName', width: 120, ellipsis: true },
          { title: '规格', dataIndex: 'materialStandard', width: 80, ellipsis: true },
          { title: '型号', dataIndex: 'materialModel', width: 80, ellipsis: true },
          { title: '仓库', dataIndex: 'depotName', width: 80, ellipsis: true },
          { title: '入库单价', dataIndex: 'inPrice', width: 80, align: 'right' },
          { title: '入库单号', dataIndex: 'inBillNo', width: 140, ellipsis: true, scopedSlots: { customRender: 'inBillNoCustomRender' } },
          { title: '出库单号', dataIndex: 'outBillNo', width: 140, ellipsis: true, scopedSlots: { customRender: 'outBillNoCustomRender' } },
          {
            title: '已出库', dataIndex: 'isSell', width: 70, align: 'center',
            customRender: function (t) { return t === '1' ? '是' : '否' }
          },
          { title: '创建时间', dataIndex: 'createTimeStr', width: 150, ellipsis: true },
          { title: '更新时间', dataIndex: 'updateTimeStr', width: 150, ellipsis: true }
        ],
        url: {
          list: '/api/plugin/serial-number-statistics/serialNumberStatistics/getList'
        },
        printDataSource: [],
        printMode: false,
        printTitle: '序列号统计-打印预览',
        isorter: {
          column: 'createTime',
          order: 'desc'
        }
      }
    },
    created() {
      this.getDepotData()
      this.loadCategoryTreeData()
    },
    methods: {
      getLoginName,
      handleStoreTenantChange() {
        this.searchQuery()
      },
      buildPrintData(dataSource, queryParam) {
        const rows = (dataSource || []).map((item, idx) => ({
          rowIndex: idx + 1,
          serialNumber: item.serialNumber || '',
          materialCode: item.materialCode || '',
          materialName: item.materialName || '',
          materialStandard: item.materialStandard || '',
          materialModel: item.materialModel || '',
          depotName: item.depotName || '',
          inPrice: item.inPrice || 0,
          inBillNo: item.inBillNo || '',
          outBillNo: item.outBillNo || '',
          isSell: item.isSell === '1' ? '是' : '否',
          createTimeStr: item.createTimeStr || '',
          updateTimeStr: item.updateTimeStr || ''
        }))
        return {
          reportTitle: '序列号统计',
          reportDate: new Date().toLocaleDateString(),
          serialNumber: (queryParam && queryParam.serialNumber) || '',
          materialParam: (queryParam && queryParam.materialParam) || '',
          depotName: (queryParam && queryParam.depotName) || '',
          dateRange: '',
          table: rows,
          total_inPrice: 0,
          creatorName: getLoginName()
        }
      },
      getDepotData() {
        getAction('/depot/findDepotByCurrentUser').then((res) => {
          if (res && res.code === 200) {
            this.depotList = res.data || []
          }
        })
      },
      loadCategoryTreeData() {
        queryMaterialCategoryTreeList({ id: '' }).then((res) => {
          if (res) {
            this.categoryTree = res
          }
        })
      },
      loadData() {
        const params = {
          serialNumber: this.queryParam.serialNumber || undefined,
          materialParam: this.queryParam.materialParam || undefined,
          isSell: this.queryParam.isSell || undefined,
          depotId: this.queryParam.depotId || undefined,
          billNo: this.queryParam.billNo || undefined,
          categoryId: this.queryParam.categoryId || undefined,
          column: this.isorter.column || 'createTime',
          order: this.isorter.order || 'desc',
          currentPage: this.ipagination.current,
          pageSize: this.ipagination.pageSize - 1
        }
        this.loading = true
        getAction(this.url.list, params).then((res) => {
          if (res && res.code === 200 && res.data) {
            const rows = res.data.rows || []
            rows.forEach((row, i) => {
              row.rowIndex = (this.ipagination.current - 1) * (this.ipagination.pageSize - 1) + i + 1
            })
            this.dataSource = rows
            this.ipagination.total = res.data.total || 0
            this.inPriceTotalStr = (res.data.inPriceTotal != null ? res.data.inPriceTotal : 0).toFixed(2)
            this.addTotalRow(rows)
          } else {
            this.dataSource = []
            this.ipagination.total = 0
            this.inPriceTotalStr = '0.00'
          }
          this.loading = false
        }).catch((err) => {
          this.loading = false
          console.error(err)
        })
      },
      addTotalRow(dataSource) {
        if (dataSource.length === 0) return
        let total = 0
        dataSource.forEach(row => {
          if (row.inPrice) {
            total += Number.parseFloat(row.inPrice)
          }
        })
        dataSource.push({
          rowIndex: '合计',
          serialNumber: '',
          materialCode: '',
          materialName: '',
          materialStandard: '',
          materialModel: '',
          depotName: '',
          inPrice: parseFloat(total.toFixed(2)),
          inBillNo: '',
          outBillNo: '',
          isSell: '',
          createTimeStr: '',
          updateTimeStr: ''
        })
      },
      searchQuery() {
        this.ipagination.current = 1
        this.loadData()
      },
      searchReset() {
        this.queryParam = {
          serialNumber: '',
          materialParam: '',
          isSell: undefined,
          depotId: undefined,
          billNo: '',
          categoryId: undefined
        }
        this.ipagination.current = 1
        this.loadData()
      },
      handleTableChange(pagination, filters, sorter) {
        if (Object.keys(sorter).length > 0) {
          if (sorter.order) {
            this.isorter.column = sorter.field
            this.isorter.order = 'ascend' === sorter.order ? 'asc' : 'desc'
          } else {
            this.isorter.column = 'createTime'
            this.isorter.order = 'desc'
          }
        }
        this.loadData()
      },
      paginationChange(page, pageSize) {
        this.ipagination.current = page
        this.ipagination.pageSize = pageSize
        this.loadData()
      },
      paginationShowSizeChange(current, size) {
        this.ipagination.current = 1
        this.ipagination.pageSize = size
        this.loadData()
      },
      async fetchAllData() {
        const pageSize = 500
        let allRows = []
        let total = 0
        const baseParams = {
          serialNumber: this.queryParam.serialNumber || undefined,
          materialParam: this.queryParam.materialParam || undefined,
          isSell: this.queryParam.isSell || undefined,
          depotId: this.queryParam.depotId || undefined,
          billNo: this.queryParam.billNo || undefined,
          categoryId: this.queryParam.categoryId || undefined,
          column: this.isorter.column || 'createTime',
          order: this.isorter.order || 'desc',
          pageSize: pageSize
        }
        const firstRes = await getAction(this.url.list, { ...baseParams, currentPage: 1 })
        if (firstRes && firstRes.code === 200 && firstRes.data) {
          total = firstRes.data.total || 0
          allRows = allRows.concat(firstRes.data.rows || [])
        }
        const totalPages = Math.ceil(total / pageSize)
        for (let page = 2; page <= totalPages; page++) {
          const res = await getAction(this.url.list, { ...baseParams, currentPage: page })
          if (res && res.code === 200 && res.data) {
            allRows = allRows.concat(res.data.rows || [])
          }
        }
        allRows.forEach((row, i) => {
          row.rowIndex = i + 1
        })
        return allRows
      },
      async handlePrint() {
        this.loading = true
        try {
          const allRows = await this.fetchAllData()
          if (!allRows || allRows.length === 0) {
            this.$message.warning('暂无数据可打印')
            return
          }
          this.printDataSource = allRows
          this.printTitle = '序列号统计-打印预览'
          this.printMode = true
        } catch (err) {
          this.$message.error('获取打印数据失败: ' + (err.message || '未知错误'))
          console.error(err)
        } finally {
          this.loading = false
        }
      },
      onDesignerChange(visible) {
        this.printTitle = visible ? '序列号统计-报表设计' : '序列号统计-打印预览'
      },
      handleBillClick(number) {
        if (!number) return
        const billType = this.getBillTypeByNumber(number)
        if (!billType) {
          this.$message.warning('无法识别该单据类型')
          return
        }
        this.$refs.modalDetail.isCanBackCheck = false
        this.$refs.modalDetail.show({ number: number }, billType.type, billType.prefixNo)
        this.$refs.modalDetail.title = billType.type + '-详情'
      },
      getBillTypeByNumber(number) {
        if (!number) return null
        const map = [
          { prefix: 'QTRK', type: '其它入库' },
          { prefix: 'QTCK', type: '其它出库' },
          { prefix: 'CGRK', type: '采购入库' },
          { prefix: 'CGTH', type: '采购退货出库' },
          { prefix: 'CGDD', type: '采购订单' },
          { prefix: 'QGD', type: '请购单' },
          { prefix: 'XSCK', type: '销售出库' },
          { prefix: 'XSTH', type: '销售退货入库' },
          { prefix: 'XSDD', type: '销售订单' },
          { prefix: 'LSCK', type: '零售出库' },
          { prefix: 'LSTH', type: '零售退货入库' },
          { prefix: 'DBCK', type: '调拨出库' },
          { prefix: 'ZZD', type: '组装单' },
          { prefix: 'CXD', type: '拆卸单' },
          { prefix: 'PDFP', type: '盘点复盘' },
          { prefix: 'PDLR', type: '盘点录入' }
        ]
        for (let i = 0; i < map.length; i++) {
          if (number.indexOf(map[i].prefix) >= 0) {
            return { type: map[i].type, prefixNo: map[i].prefix }
          }
        }
        return null
      },
      modalFormOk() {},
      modalFormClose() {},
      async exportExcel() {
        this.loading = true
        try {
          const allRows = await this.fetchAllData()
          if (!allRows || allRows.length === 0) {
            this.$message.warning('暂无数据可导出')
            return
          }
          const list = []
          const head = '序列号,条码,名称,规格,型号,仓库,入库单价,入库单号,出库单号,已出库,创建时间,更新时间'
          for (let i = 0; i < allRows.length; i++) {
            const ds = allRows[i]
            list.push([
              ds.serialNumber || '',
              ds.materialCode || '',
              ds.materialName || '',
              ds.materialStandard || '',
              ds.materialModel || '',
              ds.depotName || '',
              ds.inPrice || 0,
              ds.inBillNo || '',
              ds.outBillNo || '',
              ds.isSell === '1' ? '是' : '否',
              ds.createTimeStr || '',
              ds.updateTimeStr || ''
            ])
          }
          let inTotal = 0
          allRows.forEach(ds => { inTotal += Number.parseFloat(ds.inPrice || 0) })
          list.push(['-', '-', '-', '-', '-', '-', parseFloat(inTotal.toFixed(2)), '-', '-', '-', '-', '-'])
          this.handleExportXlsPost('序列号统计', '序列号统计', head, '', list)
        } catch (err) {
          this.$message.error('导出失败: ' + (err.message || '未知错误'))
          console.error(err)
        } finally {
          this.loading = false
        }
      }
    }
  }
</script>

<style scoped>
</style>